export const CHANGE_DATA_NAV = 'CHANGE_DATA_NAV'

const initNav = {
  title: '',
  secondaryLogo: null,
  icon: '',
  image: '',
  open: false,
}

export function nav(nav=initNav, action) {
  switch(action.type) {
    case CHANGE_DATA_NAV:
      return {
        ...nav,
        ...action.data,
      }
    default:
      return nav
  }
}
